/**
 * Rule that checks whether arrows coming out of gateways are meaningful
 */
const { is } = require("bpmnlint-utils");

module.exports = function gatewayMinOutgoing() {
  return {
    check(node, reporter) {
      if (!node) return;

      const isParallel = is(node, "bpmn:ParallelGateway");
      const isInclusive = is(node, "bpmn:InclusiveGateway");
      const isExclusive = is(node, "bpmn:ExclusiveGateway");

      if (!isParallel && !isInclusive && !isExclusive) return;

      const outgoing = Array.isArray(node.outgoing) ? node.outgoing : [];
      const incoming = Array.isArray(node.incoming) ? node.incoming : [];

      const isJoinGateway = incoming.length > 1 && outgoing.length === 1;
      if (isJoinGateway) return;

      if (outgoing.length === 1 && incoming.length >= 1) {
        if (isParallel) {
          reporter.report(
            node.id,
            "Parallel Gateway with a single outgoing path is meaningless. It should have at least two outgoing paths or be removed."
          );
        } else if (isInclusive) {
          reporter.report(
            node.id,
            "Inclusive Gateway with a single outgoing path is meaningless. It should have at least two outgoing paths or be removed."
          );
        } else if (isExclusive) {
          reporter.report(
            node.id,
            "Exclusive Gateway with a single outgoing path is meaningless. It should have at least two outgoing paths or be removed."
          );
        }
      }
    }
  };
};
